import * as React from 'react'
import { Dialog as BaseDialog } from '@base-ui/react/dialog'
import { Button, ButtonVariant, ButtonTone, ButtonSize, ButtonShape } from '../../button'
import type { PartProps } from '../../../lib/part-props'

interface DialogTriggerProps extends PartProps<React.ComponentProps<typeof BaseDialog.Trigger>> {
  className?: string
  variant?: ButtonVariant
  tone?: ButtonTone
  size?: ButtonSize
  shape?: ButtonShape
}

export function DialogTrigger({
  className,
  render,
  children,
  variant,
  tone,
  size,
  shape,
  ...props
}: DialogTriggerProps) {
  if (render) {
    return <BaseDialog.Trigger render={render} {...props} />
  }

  return (
    <BaseDialog.Trigger
      render={
        <Button variant={variant} tone={tone} size={size} shape={shape} className={className}>
          {children}
        </Button>
      }
      {...props}
    />
  )
}
